import { useRef, useLayoutEffect, useState, type ReactNode } from 'react';

import Tooltip from 'components/partials/tooltip/tooltip';

interface TruncatedCellProps {
  value: ReactNode;
}

const TruncatedCell = ({ value }: TruncatedCellProps): React.JSX.Element => {
  const textRef = useRef<HTMLDivElement | null>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const element = textRef.current;

    if (element) {
      setIsTruncated(element.scrollWidth > element.clientWidth);
    }
  }, [value]);

  return (
    <Tooltip content={value} enabled={isTruncated} position="top-start">
      <div
        ref={textRef}
        className="truncate"
      >
        {value}
      </div>
    </Tooltip>
  );
};

export default TruncatedCell;
